import React, { Component, PropTypes } from 'react';

export class About extends Component {
    render() {
        return (
            <div>
                About
                <hr />
            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js